// 9fbef606107a605d69c0edbcd8029e5d
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

export const imageStyle = {
  display: 'block',
};

export const ShimmerBox = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.2s infinite ease-in-out;
  border-radius: 4px;
`;

export const ImageBannerSkeleton = styled(ShimmerBox)`
  width: 100%;
  height: 500px;
  border-radius: 6px;

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    height: 200px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    height: 300px;
  }
`;

export const Container = styled.div`
  &[class$='-bundle-page-container'] {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;